/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_1Inputs */

const en_bot_does_1 = /** @type {(inputs: Bot_Does_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reads once, when a user asks: the entered page, then at most 12 public pages of the same site (picked from its navigation, sitemap and llms.txt).`)
};

const id_bot_does_1 = /** @type {(inputs: Bot_Does_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membaca satu kali saat pengguna meminta: halaman yang dimasukkan, lalu maksimal 12 halaman publik dari situs yang sama (dipilih dari navigasi, sitemap, dan llms.txt).`)
};

/**
* | output |
* | --- |
* | "Reads once, when a user asks: the entered page, then at most 12 public pages of the same site (picked from its navigation, sitemap and llms.txt)." |
*
* @param {Bot_Does_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_1 = /** @type {((inputs?: Bot_Does_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_1(inputs)
	return en_bot_does_1(inputs)
});